<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.currencies.add.title") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewMoneda)">
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed ? 'La longitud mínima para el nombre es de 2 ' : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.currencies.headers.name')"
                v-model="item.nombre"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed ? 'La longitud mínima para el nombre es de 2 ' : null
                "
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.currencies.headers.abbreviation')"
                v-model="item.abreviatura"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 form-group has-label">
            <div class="row">
              <label style="margin-left: 15px">{{
                $t("app.general.active")
              }}</label>
            </div>
            <template>
              <n-switch v-model="item.activo">
                <i class="now-ui-icons ui-1_check" slot="on"></i>
                <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
              </n-switch>
            </template>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  components: {},
  data() {
    return {
      selectIncompleto: false,
      item: {
        idTipoMoneda: 0,
        nombre: "",
        abreviatura: "",
        activo: true,
        idEmpresa: 0
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modals: {
        classic: false,
        notice: false,
        mini: false
      }
    };
  },
  mounted() {
    EventBus.$on("monedas-add", async () => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modals.classic = true;
    });
  },
  methods: {
    cancelAdd() {
      this.item.nombre = "";
      this.item.abreviatura = "";
      this.item.activo = true;
      this.modals.classic = false;
      this.$refs.formAdd.reset();
    },
    async submitNewMoneda() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.addNewRow();
      this.$swal.close();
    },
    async addNewRow() {
      await this.$http
        .post(route("TipoMoneda/addTipoMoneda"), this.item)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.cancelAdd();
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
